/**
 * SignupPage Data
 *
 * Generated from Contentful export
 * Last updated: 2026-01-14T05:29:54.921Z
 *
 * ⚠️  IMPORTANT: This file contains embedded content references for rich text fields.
 * Do not manually edit the 'raw' or 'references' properties.
 */

export const signupPageData = [
  {
    id: '2TzXunbjJerWHlQ1wd26uL',
    contentful_id: '2TzXunbjJerWHlQ1wd26uL',
    createdAt: '2024-06-06T19:43:03.386Z',
    updatedAt: '2024-06-06T21:45:28.841Z',
    __typename: 'signupPage',
    pageName: 'Signup Page (b)',
    headingH1:
      'Build your ideal data import solution with Flatfile - <em>it’s free</em>',
    heroCtaLabel: 'Create your account here',
    heroCtaUrl: 'https://flatfile.com/account/sign-up/',
    featureSectionTitle: 'Get started with the Flatfile Data Exchange Platform',
    featureList: [
      'Rich library of developer-friendly APIs for data-file import',
      'Fully customizable to your workflows and brand',
      'AI-assisted for better matches and continuous learning',
      'Highly intuitive, workbook-style end user experience',
      'Enterprise-scale to support the most demanding needs'
    ],
    featureSectionImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: 'ntKcZTQx2Jn0BZb7FpyX2',
        type: 'Asset',
        createdAt: '2024-04-26T18:24:05.350Z',
        updatedAt: '2024-04-26T18:24:05.350Z',
        environment: null,
        publishedVersion: 3,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Group 27517',
        description: null,
        file: {
          url: '/img/contentful/ntKcZTQx-group_27517.webp',
          details: {
            size: 75426,
            image: {
              width: 1652,
              height: 1228
            }
          },
          fileName: 'Group 27517.png',
          contentType: 'image/png'
        }
      }
    },
    urlSlug: 'signup-page-b',
    hero: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: 'ome97EegyI0D2UuAjLeYh',
        type: 'Entry',
        createdAt: '2024-06-06T17:55:06.786Z',
        updatedAt: '2024-06-06T19:07:53.870Z',
        environment: null,
        publishedVersion: 19,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'No Form Sign Up Page Hero',
        heading: 'Build your ideal data import solution with Flatfile',
        bodyText:
          "From one-click CVS imports to enterprise data preparation and collaboration, use Flatfile's powerful SDK's for solving any user-facing data import, mapping, correction and cleaning problems.",
        ctaButtons: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '2m15gFtIsKS6MJpC2QmGyl',
              type: 'Entry',
              createdAt: '2024-06-06T17:54:37.071Z',
              updatedAt: '2024-06-06T19:07:45.399Z',
              environment: null,
              publishedVersion: 7,
              revision: 2,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Create your free account',
              buttonText: 'Create your free account',
              buttonUrl: '/account/sign-up/',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ]
      }
    },
    logoBar: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: 'LOMJxaVX0u1ONyTFW6pb5',
        type: 'Entry',
        createdAt: '2024-06-06T18:34:58.525Z',
        updatedAt: '2024-06-06T19:04:13.730Z',
        environment: null,
        publishedVersion: 6,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        name: 'Default logo banner (dark)',
        title:
          'HUNDREDS OF BUSINESSES TURN FILES INTO API-READY DATA WITH FLATFILE',
        logos: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3ei9gfzgL9QLJeyy2HmTP6',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.159Z',
              updatedAt: '2024-04-29T20:24:29.159Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'adp-white',
              file: {
                url: '/img/contentful/3ei9gfzg-adp-white.webp',
                details: {
                  size: 1977,
                  image: {
                    width: 122,
                    height: 80
                  }
                },
                fileName: 'adp-white.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '26kjDfcON26RQVEJbZNXXg',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.130Z',
              updatedAt: '2024-04-29T20:24:29.130Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'servicetitan-white',
              file: {
                url: '/img/contentful/26kjDfcO-servicetitan-white.webp',
                details: {
                  size: 5514,
                  image: {
                    width: 376,
                    height: 64
                  }
                },
                fileName: 'servicetitan-white.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '4Jy5eoBgJQDkOY8xeotPA8',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.199Z',
              updatedAt: '2024-04-29T20:24:29.199Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'square-white',
              file: {
                url: '/img/contentful/4Jy5eoBg-square-white.webp',
                details: {
                  size: 2842,
                  image: {
                    width: 256,
                    height: 64
                  }
                },
                fileName: 'square-white.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '4ESxaDFQpiwn7bIhtDONB1',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.195Z',
              updatedAt: '2024-04-29T20:24:29.195Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'clickup-white',
              file: {
                url: '/img/contentful/4ESxaDFQ-clickup-white.webp',
                details: {
                  size: 3175,
                  image: {
                    width: 268,
                    height: 64
                  }
                },
                fileName: 'clickup-white.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '4idwI72tNO5lVZu5DGkDjS',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.196Z',
              updatedAt: '2024-04-29T20:24:29.196Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'astrazeneca-white',
              file: {
                url: '/img/contentful/4idwI72t-astrazeneca-white.webp',
                details: {
                  size: 4398,
                  image: {
                    width: 356,
                    height: 48
                  }
                },
                fileName: 'astrazeneca-white.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '5CQIgvu1JIyYd72VhBsgZb',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.205Z',
              updatedAt: '2024-04-29T20:24:29.205Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'sage-white',
              file: {
                url: '/img/contentful/5CQIgvu1-sage-white.webp',
                details: {
                  size: 2254,
                  image: {
                    width: 148,
                    height: 56
                  }
                },
                fileName: 'sage-white.png',
                contentType: 'image/png'
              }
            }
          }
        ],
        theme: 'Dark'
      }
    },
    featuresSection: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: 'jTJ6ZgaRZ39lDMk5mQxte',
          type: 'Entry',
          createdAt: '2024-06-06T17:57:11.240Z',
          updatedAt: '2024-06-06T18:41:55.665Z',
          environment: null,
          publishedVersion: 8,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Get started with the Flatfile Data Exchange Platform',
          heading: 'Get started with the Flatfile Data Exchange Platform',
          checklist: [
            'Rich library of developer-friendly APIs for data-file import',
            'Fully customizable to your workflows and brand',
            'AI-assisted for better matches and continuous learning',
            'Highly intuitive, workbook-style end user experience',
            'Enterprise-scale to support the most demanding needs'
          ],
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '7boCDbEPNKHvVSJee9fkQz',
              type: 'Asset',
              createdAt: '2024-06-06T17:57:01.969Z',
              updatedAt: '2024-06-06T17:57:01.969Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'Get started with the Flatfile Data Exchange Platform',
              description: null,
              file: {
                url: '/img/contentful/7boCDbEP-group_27517.webp',
                details: {
                  size: 49830,
                  image: {
                    width: 1652,
                    height: 1228
                  }
                },
                fileName: 'Group_27517.png?w=1652&h=1228&q=70&fm=webp',
                contentType: 'image/webp'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: 'yKiYZmDodJCAmhk9fvyI9',
          type: 'Entry',
          createdAt: '2024-06-06T18:02:59.886Z',
          updatedAt: '2024-06-06T18:55:17.300Z',
          environment: null,
          publishedVersion: 9,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Enterprise scale',
          heading: 'Enterprise scale',
          checklistWithIcons: [
            {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: 'ql58mJ35dJ3xu1JHbbx1l',
                type: 'Entry',
                createdAt: '2024-06-06T18:00:53.608Z',
                updatedAt: '2024-07-26T21:30:34.219Z',
                environment: null,
                publishedVersion: 6,
                revision: 2,
                contentType: null,
                locale: 'en-US'
              },
              fields: {
                title: 'Built to meet enterprise standards',
                iconName: '<i class="fa-sharp fa-light fa-code-branch"></i>',
                blurb:
                  'Flatfile is SOC 2, HIPAA, and GDPR compliant. We comply with industry regulations and standards to keep data safe.'
              }
            },
            {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '2YShAZKceyIFck2CTDhZob',
                type: 'Entry',
                createdAt: '2024-06-06T18:01:33.777Z',
                updatedAt: '2024-06-06T18:01:33.777Z',
                environment: null,
                publishedVersion: 4,
                revision: 1,
                contentType: null,
                locale: 'en-US'
              },
              fields: {
                title: 'Runs on secure cloud infrastructure',
                iconName: 'cloud',
                blurb:
                  'Flatfile is built on modern cloud technologies. Partnering with Amazon S3, we provide industry-leading scalability and performance.'
              }
            },
            {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '4vPdzYNFoGEhV3Q2nLDNnn',
                type: 'Entry',
                createdAt: '2024-06-06T18:02:11.472Z',
                updatedAt: '2024-06-06T18:02:11.472Z',
                environment: null,
                publishedVersion: 4,
                revision: 1,
                contentType: null,
                locale: 'en-US'
              },
              fields: {
                title: 'Designed to support the most demanding needs',
                iconName: 'right-left-large',
                blurb:
                  'From very large file support to parallel processing and load balancing, you can rely on a platform that scales to support the most rigorous enterprise needs.'
              }
            },
            {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '26rdkaNk2FDS6wvRSwKZ3c',
                type: 'Entry',
                createdAt: '2024-06-06T18:02:36.448Z',
                updatedAt: '2024-06-06T18:02:36.448Z',
                environment: null,
                publishedVersion: 3,
                revision: 1,
                contentType: null,
                locale: 'en-US'
              },
              fields: {
                title: 'Treating data transfers with care',
                iconName: 'lock',
                blurb:
                  "With one of the strongest block ciphers available, AES-256, your data is protected both while in transit and once it's stored."
              }
            }
          ],
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6NFVa8CxYjssfhG2okhfUM',
              type: 'Asset',
              createdAt: '2024-06-06T18:55:12.219Z',
              updatedAt: '2024-06-06T18:55:12.219Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'enterprise-scale',
              description: null,
              file: {
                url: '/img/contentful/6NFVa8Cx-enterprise-scale.avif.webp',
                details: {
                  size: 13109,
                  image: {
                    width: 558,
                    height: 481
                  }
                },
                fileName: 'enterprise-scale.avif',
                contentType: 'image/avif'
              }
            }
          }
        }
      }
    ],
    customerQuote: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '7yPL5PdQjICnpQ4VpXuKEg',
        type: 'Entry',
        createdAt: '2024-06-06T18:05:27.129Z',
        updatedAt: '2024-06-06T18:05:27.129Z',
        environment: null,
        publishedVersion: 6,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'Flow quote',
        theme: true,
        body: 'It creates an importing experience that handles the complexity behind the scenes and all the customer sees is a drop dead, simple user interface that makes the importing process easy for anyone on their team to handle.',
        quotee: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '50stQJuGmnN4xSQYMZL33u',
            type: 'Entry',
            createdAt: '2024-06-06T18:04:57.073Z',
            updatedAt: '2024-06-06T18:04:57.073Z',
            environment: null,
            publishedVersion: 4,
            revision: 1,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            fullName: 'Daniel Scrivner',
            headshot: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '6xQR6STMZylOjR2zD2f0bK',
                type: 'Asset',
                createdAt: '2024-06-06T18:04:35.202Z',
                updatedAt: '2024-06-06T18:04:35.202Z',
                environment: null,
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'daniel-flow',
                description: null,
                file: {
                  url: '/img/contentful/6xQR6STM-daniel-flow.webp',
                  details: {
                    size: 60807,
                    image: {
                      width: 592,
                      height: 592
                    }
                  },
                  fileName: 'daniel-flow.jpeg',
                  contentType: 'image/jpeg'
                }
              }
            },
            jobTitle: 'CEO',
            company: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '2ww66rxBYpbXqZMd6MsPnl',
                type: 'Entry',
                createdAt: '2022-09-20T22:25:47.029Z',
                updatedAt: '2024-06-06T19:31:45.433Z',
                environment: null,
                publishedVersion: 18,
                revision: 7,
                contentType: null,
                locale: 'en-US'
              },
              fields: {
                name: 'Flow',
                logo: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '4VySpwHYjo7TvPgQQwRc6M',
                    type: 'Asset',
                    createdAt: '2023-01-25T17:17:19.449Z',
                    updatedAt: '2023-01-25T17:17:19.449Z',
                    environment: null,
                    publishedVersion: 4,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'Flow Logo',
                    description: null,
                    file: {
                      url: '/img/contentful/4VySpwHY-flow.webp',
                      details: {
                        size: 2457,
                        image: {
                          width: 173,
                          height: 48
                        }
                      },
                      fileName: 'flow.png',
                      contentType: 'image/png'
                    }
                  }
                },
                logoBlack: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '2A3GgfXAHIC1puF3MEWVIC',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.141Z',
                    updatedAt: '2024-04-29T20:24:29.141Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'flow',
                    file: {
                      url: '/img/contentful/2A3GgfXA-flow.webp',
                      details: {
                        size: 1573,
                        image: {
                          width: 204,
                          height: 56
                        }
                      },
                      fileName: 'flow.png',
                      contentType: 'image/png'
                    }
                  }
                },
                logoWhite: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '6pcSKQ1ZOOogbARO6ilRGq',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.217Z',
                    updatedAt: '2024-04-29T20:24:29.217Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'flow-white',
                    file: {
                      url: '/img/contentful/6pcSKQ1Z-flow-white.webp',
                      details: {
                        size: 1697,
                        image: {
                          width: 204,
                          height: 56
                        }
                      },
                      fileName: 'flow-white.png',
                      contentType: 'image/png'
                    }
                  }
                },
                coverPhoto: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '156JazXhZ9IFS1pUK6wOoH',
                    type: 'Asset',
                    createdAt: '2023-01-13T21:10:42.120Z',
                    updatedAt: '2023-01-13T21:10:42.120Z',
                    environment: null,
                    publishedVersion: 6,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'Project Management Image',
                    description: null,
                    file: {
                      url: '/img/contentful/156JazXh-marten-bjork-rh8o0fhfpfw-unsplash.webp',
                      details: {
                        size: 1856510,
                        image: {
                          width: 5370,
                          height: 3580
                        }
                      },
                      fileName: 'marten-bjork-rH8O0FHFpfw-unsplash.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                industry: 'Software',
                size: '10+',
                productsUtilized: 'Portal',
                website: 'getflow.com'
              }
            }
          }
        },
        photo: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '6xQR6STMZylOjR2zD2f0bK',
            type: 'Asset',
            createdAt: '2024-06-06T18:04:35.202Z',
            updatedAt: '2024-06-06T18:04:35.202Z',
            environment: null,
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'daniel-flow',
            description: null,
            file: {
              url: '/img/contentful/6xQR6STM-daniel-flow.webp',
              details: {
                size: 60807,
                image: {
                  width: 592,
                  height: 592
                }
              },
              fileName: 'daniel-flow.jpeg',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    guidedBlocksSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: 'e86zQlz5EymBRKxNI9ENK',
        type: 'Entry',
        createdAt: '2024-06-06T21:33:53.605Z',
        updatedAt: '2024-06-06T21:33:53.605Z',
        environment: null,
        publishedVersion: 6,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        internalName: 'Default getting started blocks',
        title: 'Getting started is easy',
        bodyText:
          'Explore the Flatfile Data Exchange Platform and build the ideal data file import experience for your users - faster, easier and safer.',
        cards: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6psbXPf1T3uf8evwJ0VFDL',
              type: 'Entry',
              createdAt: '2024-06-06T21:33:13.458Z',
              updatedAt: '2024-06-06T21:33:13.458Z',
              environment: null,
              publishedVersion: 6,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'General Start',
              title: 'Start',
              bodyText:
                'Get your free Flatfile account and experience the full power of the Flatfile Data Exchange Platform',
              linkText: "Start now, it's free",
              linkUrl: '/account/sign-up/'
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '2fRUQ32Up5m7p9pBvzI01E',
              type: 'Entry',
              createdAt: '2024-06-06T21:33:47.502Z',
              updatedAt: '2024-06-06T21:33:47.502Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'General Demo',
              title: 'Demo',
              bodyText: 'Get a custom sales demo for your use case',
              linkText: 'Contact us',
              linkUrl: '/demo/'
            }
          }
        ]
      }
    }
  },
  {
    id: '7m27081QekX5ojhHAxwRlJ',
    contentful_id: '7m27081QekX5ojhHAxwRlJ',
    createdAt: '2023-08-07T22:40:37.942Z',
    updatedAt: '2024-06-06T17:51:07.818Z',
    __typename: 'signupPage',
    pageName: 'Signup Page',
    headingH1:
      'Build your ideal data import solution with Flatfile - <em>it’s free</em>',
    heroCtaLabel: 'Create your account here',
    heroCtaUrl: 'https://flatfile.com/account/sign-up/',
    featureSectionTitle: 'Get started with the Flatfile Data Exchange Platform',
    featureList: [
      'Rich library of developer-friendly APIs for data-file import',
      'Fully customizable to your workflows and brand',
      'AI-assisted for better matches and continuous learning',
      'Highly intuitive, workbook-style end user experience',
      'Enterprise-scale to support the most demanding needs'
    ],
    featureSectionImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: 'ntKcZTQx2Jn0BZb7FpyX2',
        type: 'Asset',
        createdAt: '2024-04-26T18:24:05.350Z',
        updatedAt: '2024-04-26T18:24:05.350Z',
        environment: null,
        publishedVersion: 3,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Group 27517',
        description: null,
        file: {
          url: '/img/contentful/ntKcZTQx-group_27517.webp',
          details: {
            size: 75426,
            image: {
              width: 1652,
              height: 1228
            }
          },
          fileName: 'Group 27517.png',
          contentType: 'image/png'
        }
      }
    },
    urlSlug: 'sign-up'
  }
] as const

export type SignupPage = (typeof signupPageData)[number]

export default signupPageData
